module.exports = __webpack_public_path__ + "static/img/VVV.2b7a301.png";